import React from "react";

const PageHeader = ({ title, breadcrumbs }) => {
  return (
    <div className="page-header">
      <div className="container-inner">
        <div className="breadcrumbs">
          {breadcrumbs.map((item, index) => (
            <React.Fragment key={index}>
              <span className={index === breadcrumbs.length - 1 ? "breadcrumb-item active" : "breadcrumb-item"}>
                {item}
              </span>
              {index < breadcrumbs.length - 1 && <span className="breadcrumb-separator">/</span>}
            </React.Fragment>
          ))}
        </div>
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default PageHeader;